import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=28ef107c&scoped=true&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"
import style0 from "./Integration.vue?vue&type=style&index=0&id=28ef107c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef107c",
  null
  
)

export default component.exports